const sealious_to_mongo_sort_param = {
	desc: -1,
	descending: -1,
	asc: 1,
	ascending: 1,
};

export default sealious_to_mongo_sort_param;
